import * as svgObject from './svgobject';
export default {
  usSvgObj: svgObject.getUsSvgObj,
  canadaSvgObj: svgObject.getCanadaSvgObj,
  bothStates: svgObject.bothStates,
};


// WEBPACK FOOTER //
// ./src/api/index.js